export const questionnaire = [
  {
    date: "30 เมษายน 2569",
    title:
      "แบบสำรวจความพึงพอใจและความเชื่อมั่นคุณภาพวัคซีน (กลุ่มผู้ใช้วัคซีน ณ จุดจำหน่าย สำนักงานปศุสัตว์จังหวัด)  รหัส บ.ปศจ.ก./69",
    url: "https://forms.gle/dNDBijA36ogZS8CGA",
  },
  {
    date: "30 เมษายน 2569",
    title:
      "แบบสำรวจความพึงพอใจและความเชื่อมั่นคุณภาพวัคซีน (กลุ่มผู้ใช้วัคซีน ณ จุดจำหน่าย สำนักเทคโนโลยีชีวภัณฑ์สัตว์) รหัส บ.สทช./69",
    url: "https://forms.gle/LxSK2ZUZuoq5Vj2RA",
  },
];
